import { render, staticRenderFns } from "./languages.vue?vue&type=template&id=51c956dc&scoped=true"
import script from "./languages.vue?vue&type=script&lang=js"
export * from "./languages.vue?vue&type=script&lang=js"
import style0 from "./languages.vue?vue&type=style&index=0&id=51c956dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c956dc",
  null
  
)

export default component.exports